import _ from 'underscore'
import mathjs from 'mathjs'
import moment from 'moment-timezone'

const TAX_RATE = 0

const recalculateDeliveryFee = function (state, total) {
  let deliveryFee = 0
  if (state.request.customer.pref === null) {
    deliveryFee = 0
  } else {
    let deliveryFeeMatched = _.chain(state.deliveryFeeTable)
      .find(function (deliveryFee) {
        return _.contains(deliveryFee.prefs, state.request.customer.pref)
      })
      .value()
    deliveryFee = _.chain(deliveryFeeMatched.fees)
      .find(function (fee) {
        return fee.min <= total && total <= fee.max
      })
      .value()
      .fee
  }
  return deliveryFee
}

const recalculate = function (state) {
  // 小計を算出
  let total = _.reduce(state.request.items, function (sum, item) {
    return parseInt(sum, 10) + parseInt(item.sub_total, 10)
  }, 0)
  // 消費税を算出
  let tax = mathjs.chain(total).multiply(TAX_RATE).divide(100).done()
  // 送料を算出
  // NOTE 一つでも送料無料の商品が含まれていれば送料無料
  let deliveryFee = recalculateDeliveryFee(state, total)
  const includesFree = state.request.items.filter(i => i.deliveryFeeFree).length > 0
  if (includesFree) {
    deliveryFee = 0
  }
  let codFee = _.chain(state.codFeeTable)
    .find(function (fee) {
      return fee.min <= total && total <= fee.max
    })
    .value()
    .fee

  let grandTotal = mathjs.chain(total).add(tax).add(deliveryFee).add(codFee).done()
  return {
    total: total,
    tax: tax,
    tax_rate: TAX_RATE,
    delivery_fee: deliveryFee,
    cod_fee: codFee,
    grand_total: grandTotal
  }
}

const initCustomer = function () {
  return {
    name: null,
    email: null,
    zipcode: null,
    pref: null,
    address1: null,
    address2: null,
    desired_delivery_date: null,
    desired_delivery_time: '指定なし'
  }
}

const initSummary = function () {
  return {
    total: 0,
    tax: 0,
    delivery_fee: 0,
    cod_fee: 0,
    grand_total: 0
  }
}

export default {
  namespaced: true,
  state () {
    return {
      request: {
        items: [],
        customer: initCustomer(),
        summary: initSummary()
      },
      deliveryTimeTable: [
        '午前中（12時まで）',
        '14:00〜16:00',
        '16:00〜18:00',
        '18:00〜20:00',
        '19:00〜21:00',
        '指定なし'
      ],
      codFeeTable: [
        { min: 0, max: 9999, fee: 330 },
        { min: 10000, max: 29999, fee: 440 },
        { min: 30000, max: 99999, fee: 660 },
        { min: 100000, max: 300000, fee: 1100 }
      ],
      deliveryFeeTable: [{
        regions: ['関東', '信越', '東海', '北陸', '南東北'],
        prefs: ['宮城県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県'],
        fees: [
          { min: 0, max: 0, fee: 0 },
          { min: 1, max: 2999, fee: 790 },
          { min: 3000, max: 4999, fee: 410 },
          { min: 5000, max: 7499, fee: 0 },
          { min: 7500, max: 9999, fee: 0 },
          { min: 10000, max: 300000, fee: 0 }
        ]
      }, {
        regions: ['関西'],
        prefs: ['滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県'],
        fees: [
          { min: 0, max: 0, fee: 0 },
          { min: 1, max: 2999, fee: 1000 },
          { min: 3000, max: 4999, fee: 500 },
          { min: 5000, max: 7499, fee: 0 },
          { min: 7500, max: 9999, fee: 0 },
          { min: 10000, max: 300000, fee: 0 }
        ]
      }, {
        regions: ['中国', '四国', '北東北'],
        prefs: ['青森県', '岩手県', '秋田県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県'],
        fees: [
          { min: 0, max: 0, fee: 0 },
          { min: 1, max: 2999, fee: 1110 },
          { min: 3000, max: 4999, fee: 560 },
          { min: 5000, max: 7499, fee: 0 },
          { min: 7500, max: 9999, fee: 0 },
          { min: 10000, max: 300000, fee: 0 }
        ]
      }, {
        regions: ['北海道', '九州'],
        prefs: ['北海道', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県'],
        fees: [
          { min: 0, max: 0, fee: 0 },
          { min: 1, max: 2999, fee: 1310 },
          { min: 3000, max: 4999, fee: 1310 },
          { min: 5000, max: 7499, fee: 660 },
          { min: 7500, max: 9999, fee: 0 },
          { min: 10000, max: 300000, fee: 0 }
        ]
      }, {
        regions: ['沖縄'],
        prefs: ['沖縄県'],
        fees: [
          { min: 0, max: 0, fee: 0 },
          { min: 1, max: 2999, fee: 3130 },
          { min: 3000, max: 4999, fee: 3130 },
          { min: 5000, max: 7499, fee: 3130 },
          { min: 7500, max: 9999, fee: 1570 },
          { min: 10000, max: 300000, fee: 0 }
        ]
      }],
      prefs: ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県']
    }
  },
  getters: {
    cart (state) {
      // console.log(JSON.stringify(state.request))
      return state.request.items
    },
    cartNum (state) {
      let num = 0
      _.each(state.request.items, function (item) {
        num += parseInt(item.num, 10)
      })
      return num
    },
    customer (state) {
      return state.request.customer
    },
    summary (state) {
      return state.request.summary
    },
    request (state) {
      return Object.assign({
        summary: {
          request_date: moment().locale('ja').format('YYYY-MM-DD'),
          request_timestamp: moment().locale('ja').format('YYYYMMDDHHmmss')
        }
      }, state.request)
    },
    deliveryTimeTable (state) {
      return state.deliveryTimeTable
    },
    codFeeTable (state) {
      return state.codFeeTable
    },
    deliveryFeeTable (state) {
      return state.deliveryFeeTable
    },
    prefs (state) {
      return state.prefs
    }
  },
  mutations: {
    reloadCart (state) {
      let cart = localStorage.getItem('cart')
      cart = cart ? JSON.parse(cart) : []
      localStorage.setItem('cart', JSON.stringify(cart))
      state.request.items = _.sortBy(cart, function (item) {
        return item.sort_order
      })
      state.request.summary = recalculate(state)
    },
    reloadCustomer (state) {
      let customer = localStorage.getItem('customer')
      state.request.customer = customer ? JSON.parse(customer) : initCustomer()
    },
    addItemToCart (state, item) {
      let cartItem = _.findWhere(state.request.items, {uuid: item.uuid})
      if (cartItem === undefined) {
        state.request.items.push({
          uuid: item.uuid,
          key: item.key,
          name: `${item.name}`,
          num: parseInt(item.num, 10),
          price: parseInt(item.price, 10),
          sub_total: parseInt(item.price, 10) * parseInt(item.num, 10),
          sort_order: parseInt(item.sortOrder, 10),
          deliveryFeeFree: item.deliveryFeeFree
        })
      } else {
        cartItem.num += parseInt(item.num, 10)
        cartItem.sub_total = parseInt(cartItem.num, 10) * parseInt(cartItem.price, 10)
      }
      state.request.items = _.sortBy(state.request.items, function (item) {
        return item.sort_order
      })
      state.request.summary = recalculate(state)
      localStorage.setItem('cart', JSON.stringify(state.request.items))
    },
    updateCustomer (state, customer) {
      Object.assign(state.request.customer, customer)
      state.request.summary = recalculate(state)
    },
    saveCustomer (state) {
      localStorage.setItem('customer', JSON.stringify(state.request.customer))
    },
    removeItem (state, item) {
      let index = _.findIndex(state.request.items, {uuid: item.uuid})
      if (index >= 0) {
        state.request.items.splice(index, 1)
        localStorage.setItem('cart', JSON.stringify(state.request.items))
      }
      state.request.summary = recalculate(state)
    },
    updateItemNum (state, payload) {
      let cartItem = _.findWhere(state.request.items, {uuid: payload.uuid})
      cartItem.num = parseInt(payload.num, 10)
      cartItem.sub_total = cartItem.num * parseInt(cartItem.price, 10)
      localStorage.setItem('cart', JSON.stringify(state.request.items))
      state.request.summary = recalculate(state)
    },
    clearCart (state) {
      localStorage.removeItem('cart')
      state.request.customer.desired_delivery_date = null
      localStorage.setItem('customer', JSON.stringify(state.request.customer))
      state.request.items = []
      state.request.summary = initSummary()
    },
    forgetMe (state) {
      localStorage.removeItem('customer')
      state.request.customer = initCustomer()
    }
  },
  actions: {
    reloadCart ({commit}) {
      commit('reloadCart')
    },
    reloadCustomer ({commit}) {
      commit('reloadCustomer')
    },
    addItemToCart ({commit}, item) {
      commit('addItemToCart', item)
    },
    updateCustomer ({commit}, customer) {
      commit('updateCustomer', customer)
    },
    saveCustomer ({commit}) {
      commit('saveCustomer')
    },
    removeItem ({commit}, item) {
      commit('removeItem', item)
    },
    updateItemNum ({commit}, payload) {
      commit('updateItemNum', payload)
    },
    clearCart ({commit}) {
      commit('clearCart')
    },
    forgetMe ({commit}) {
      commit('forgetMe')
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/Landing/store.js